export function getArticleInfo() {
  return {
    authors: getXLAuthors(),
    publishedString: getXLPublishedString(),
  }
}

function getXLAuthors() {
  return Array.from(document.querySelectorAll('.author__body')).map((authorElm) => {
    const authNameElm = authorElm.querySelector('.author__name') as HTMLAnchorElement
    const authRoleElm = authorElm.querySelector('.author__role')
    return {
      name: Array.from(authNameElm.childNodes ?? [])
        .filter((n) => n.nodeName === '#text')
        .map((n) => n.textContent)
        .join('')
        .trim(),
      href: authNameElm.href,
      role: authRoleElm.textContent,
    }
  })
}

function getXLPublishedString() {
  const publishDateElm = document.querySelector('.article-dateline__full')
  const publishDate = publishDateElm ? publishDateElm.textContent : ''

  const annotationElm = document.querySelector('.article-dateline-annotation')
  const publishAnnotation = annotationElm ? annotationElm.textContent : ''

  return `${publishAnnotation} ${publishDate}`
}
